<template>
  <el-select-tree
    @change="selectChange"
    :data="options_bank_id"
    :props="treeProps"
    v-model="selectID"
    :multiple="multiple"
    :disabled="disabled"
    collapse-tags
    :default-expand-all="true"
    :check-strictly="true"
    placeholder="默认"></el-select-tree>
</template>

<script>
  import {treeDataTranslate} from '@/utils'
  export default {
    name:'bank-select-ex',
    data () {
      return {
        selectID:this.bankId,
        treeProps: {
          value: 'id',
          children: 'children',
          label: 'bankName'
        },
        options_bank_id:[],
      }
    },
    props:{
      bankId : {
        type: [Number,Array],
        default: null
      },
      multiple: {
        type: Boolean,
        default: true
      },
      disabled : Boolean
    },
    watch:{
      bankId : function(newVal, oldVal){
        this.selectID = newVal;
      },
      selectID : function(newVal, oldVal){
        this.$emit("update:bankId", newVal);
      }
    },
    created() {
      this.getBankCondition();
    },
    methods:{
      selectChange(event, item) {
        this.$emit('select', event, item);
      },
      getBankCondition(){
        this.$http({
          url: this.$http.adornUrl('/sys/bank/getSupportBanks'),
          method: 'get',
          params: this.$http.adornParams()
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.options_bank_id = treeDataTranslate(data.data)
          }
        }).catch((err) =>{
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/bank/bank-select-ex.vue